import { render, staticRenderFns } from "./atlas_table.vue?vue&type=template&id=0007affc&scoped=true&"
import script from "./atlas_table.vue?vue&type=script&lang=js&"
export * from "./atlas_table.vue?vue&type=script&lang=js&"
import style0 from "./atlas_table.vue?vue&type=style&index=0&id=0007affc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0007affc",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\1603014\\develop\\qplus\\qpeplus\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0007affc', component.options)
    } else {
      api.reload('0007affc', component.options)
    }
    module.hot.accept("./atlas_table.vue?vue&type=template&id=0007affc&scoped=true&", function () {
      api.rerender('0007affc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/atlas/_tool/atlas_table.vue"
export default component.exports